export default __webpack_public_path__ + "static/media/il_proceso_connect.490c5ca3.svg";